import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { personalTraining } from '../services/api';
import '../styles/ui.css';

// Personal Training do sócio: o pacote ativo e as sessões — sem comissão, receita ou notas internas. Módulo PersonalTraining (403 → desligado).
const STATUS = { Scheduled: ['Agendada', 'is-info'], Completed: ['Concluída', 'is-good'], Cancelled: ['Cancelada', ''], NoShow: ['Falta', 'is-warn'] };
const fmt = (d) => (d ? new Date(d).toLocaleString('pt-PT', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');

export default function ClientPtPage() {
  const [pkgs, setPkgs] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    Promise.all([personalTraining.myPackages(), personalTraining.mySessions()])
      .then(([p, s]) => { setPkgs(p.data); setSessions(s.data); setState('ok'); })
      .catch((e) => setState(e?.response?.status === 403 ? 'disabled' : 'error'));
  }, []);

  if (state === 'loading') return <div className="gm-page"><div className="gm-skeleton" aria-busy="true" aria-label="A carregar" /></div>;
  if (state === 'disabled') return <div className="gm-page"><div className="gm-empty"><strong>Personal Training não está disponível</strong>Este ginásio não tem o módulo ligado.</div></div>;
  if (state === 'error') return <div className="gm-page"><div className="gm-error" role="alert">Não foi possível carregar o Personal Training.</div></div>;

  const active = (pkgs || []).find((p) => p.status === 'Active');
  const upcoming = sessions.filter((s) => s.status === 'Scheduled');

  return (
    <div className="gm-page" data-testid="client-pt">
      <div className="gm-grid">
        <section className="gm-card gm-col-4" aria-label="Pacote ativo">
          <div className="gm-card-head"><h3 className="gm-card-title">Pacote ativo</h3></div>
          {active ? (
            <div className="gm-stat">
              <span className="gm-stat-value">{active.remaining}</span>
              <span className="gm-stat-label">{active.remaining === 1 ? 'sessão restante' : 'sessões restantes'}</span>
              {active.validUntil && <span className="gm-note" style={{ marginTop: 8 }}>Válido até {new Date(active.validUntil).toLocaleDateString('pt-PT')}</span>}
            </div>
          ) : <p className="gm-note">Não tem um pacote de Personal Training ativo. Fale com o ginásio para adquirir um.</p>}
        </section>

        <section className="gm-card gm-col-8" aria-label="Sessões">
          <div className="gm-card-head">
            <h3 className="gm-card-title">Sessões</h3>
            {upcoming.length > 0 && <span className="gm-chip is-info"><CalendarClock size={14} aria-hidden="true" /> {upcoming.length} por vir</span>}
          </div>
          {sessions.length === 0 ? <p className="gm-note">Ainda não tem sessões marcadas.</p> : (
            <ul className="gm-list">
              {sessions.map((s) => {
                const [label, tone] = STATUS[s.status] || [s.status, ''];
                return (
                  <li key={s.id} className="gm-list-row">
                    <span className="gm-list-main"><span className="gm-list-title">{fmt(s.scheduledAt)}</span></span>
                    <span className={`gm-chip ${tone}`}>{label}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
}
